import { LanguageInput } from "../input/LanguageInput";
import { PHPResponse } from "../PHPResponse";
import {  PAGE_EVENT, PHPAdresses } from "../PHPAdress";
import { PHPRequest } from "../PHPRequest";
import { InputData } from "../input/InputData";

export class PageEventInputData extends InputData
{
  page:string;
  data:string;
  handle:string;
}

export class PageEventRequest extends PHPRequest<PAGE_EVENT,PageEventInputData,PHPResponse>
{
  constructor()
  {
    super( PHPAdresses.PAGE_EVENT );
  }
}